import * as yup from "yup";

export const invalidMemberId = "Enter your member ID as shown on your membership card.";

/** A membership number from a partner organisation (e.g. a CBM member ID). */
export const memberIdSchema = yup
  .string()
  .trim()
  .min(3, invalidMemberId)
  .max(64, invalidMemberId)
  .matches(/^[A-Za-z0-9/_-]+$/, invalidMemberId);
